/**
 * Created by pmnia on 7/1/15.
 */
(function() {
    var app = angular.module('appAssociation');
    app.config(['$stateProvider', '$locationProvider', '$ocLazyLoadProvider',
        function ($stateProvider, $locationProvider, $ocLazyLoadProvider) {

            var config = {
                docTitle: undefined,
                resolveAlways: {},
                parent:'layout'
            };

            // with lazy loading
            $stateProvider
                //Association
                .state('association', {
                    url: '/:cId',
                    controller: 'AssociationController',
                    controllerAs: 'vm',
                    parent: config.parent,
                    title: 'association',
                    data:{
                        home: 'association',
                    },
                    settings: {
                        nav: 1,
                        content: '<i class="fa fa-dashboard"></i> Association'
                    },
                    obtVid : 2,
                    obtPage: 1,
                    templateProvider: ['$q', function ($q) {
                        var deferred = $q.defer();
                        require.ensure([], function () {
                            //var isMobile = false;
                            //var templateName = isMobile ? './association/association_mobile.html' : './association/association.html';
                            //var templateName = './association/association.html';
                            var template = require('html!./association/association.html');
                            deferred.resolve(template);
                        });
                        return deferred.promise;
                    }],
                    resolve: {
                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                            var deferred = $q.defer();
                            require.ensure([], function () {
                                require('./association/association.module.js');
                                require('./association/association.controller.js');
                                $ocLazyLoad.load({
                                    name: 'app.association'
                                }).then(function(){
                                    deferred.resolve(true);
                                });
                            });

                            return deferred.promise;
                        }],
                        data_footer: /*@ngInject*/function(dataservice, $stateParams){
                            return dataservice.page.getFooterContent($stateParams.cId);
                        },
                        data_association: /*@ngInject*/function(dataservice, $stateParams){
                            return dataservice.association.getAssociation($stateParams.cId);
                        },
                        data_therapists: /*@ngInject*/function(dataservice, $stateParams){
                            return dataservice.association.getTherapists($stateParams.cId);
                        }
                    }
                })
        }]);
})();



/*****************
 ** WEBPACK FOOTER
 ** ./app/app.association.config.js
 ** module id = 283
 ** module chunks = 0
 **/